import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/icon-close-hint.svg'


const _hoisted_1 = { class: "jr-w-full jr-h-screen jr-m-auto jr-fixed jr-top-0 jr-z-60 jr-flex jr-items-center jr-justify-center" }
const _hoisted_2 = { class: "jr-relative jr-left-0 jr-right-0 jr-max-w-600 jr-min-w-600 jr-bg-white jr-m-auto jr-text-center jr-z-60" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "close"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "jr-mx-auto jr-py-12 jr-w-full jr-max-h-1^1.1 jr-overflow-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_content = _resolveComponent("content")!

  return (_openBlock(), _createBlock(_Transition, { name: "modal" }, {
    default: _withCtx(() => [
      _createElementVNode("figure", null, [
        _withDirectives(_createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args))),
            class: "jr-bg-black jr-w-full jr-h-screen jr-opacity-30 jr-z-50 jr-fixed"
          }),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              class: "jr-absolute jr-top-3.5 jr-right-3.5",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args)))
            }, _hoisted_4),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_content)
            ])
          ])
        ], 512), [
          [_vShow, _ctx.show]
        ])
      ])
    ]),
    _: 1
  }))
}